<template>
  <div>
    <div class="supplementaryMesg">
      <div class="supplementary-inputbox">
        <div class="Supplementary-name">券码：</div>
        <input class="Supplementary-input" v-model="code" />
      </div>
      <div class="supplementary-inputbox">
        <div class="Supplementary-name">操作员账号：</div>
        <input class="Supplementary-input" v-model="accnumber" />
      </div>
      <div class="supplementary-inputbox">
        <div class="Supplementary-name">操作员密码：</div>
        <input class="Supplementary-input" type="password" v-model="accpassword" />
      </div>
      <div class="supplementary-inputbox">
        <div class="Supplementary-name">商家账号：</div>
        <input class="Supplementary-input" v-model="bussnumber" />
      </div>
      <div class="supplementary-inputbox">
        <div class="Supplementary-name">上传图片：</div>
        <div class="upimage">
          <div class="img-box" v-if="show">
            <img src="/static/upimg.png" alt="" class="imgmoren">
          </div>
          <div class="img-box" v-else>
            <img :src="image" alt="" class="upimg">
          </div>
          <input type="file" accept="image/jpeg,image/png,image/jpg,image/gif" @change='getimg($event)'>
        </div>
      </div>
      <div class="supplementary-inputbox">
        <div class="Supplementary-name">车牌号：</div>
        <input class="Supplementary-input" v-model="car_no" />
        <div class="supplementary-inputboxtip">输入车牌号后，将不识别校验核销图片</div>
      </div>
      <!--<div class="supplementary-inputbox">
        <div class="Supplementary-name">验证码：</div>
        <div class="Supplementary-yanzhengma">
          <img class="Supplementary-yanzhengimg" />
          <input class="Supplementary-input1" />
        </div>
      </div>-->
      <div class="tijiao-box" @click="submit">
        <div class="Supplementary-tijiao">提交</div>
      </div>

    </div>

  </div>
</template>

<script>
  import httper from '../../api/http';
  export default {
    data() {
      return {
        code: "",
        accnumber: "",
        accpassword: "",
        bussnumber: "",
        show: true,
        image: "",
        car_no:""
      }
    },
    created() {

    },
    mounted() {

    },
    methods: {
      getimg(e) {
        console.log(e)
        let that = this;
        let requestData = {}
        var files = e.target.files[0];
        if (!files) return
        let reader = new FileReader();
        reader.readAsDataURL(files); // 读取文件
        reader.onloadend = function(res) {
          console.log(res)
          that.show = false;
          // that.image = res.currentTarget.result;
          requestData.base64_file = res.currentTarget.result;
          console.log("requestData", requestData)
          that.request("upimg", requestData)
        };

        // requestData.category = "default"

      },
      submit() {
        let that = this
        var requestData = {}
        if (!that.code) {
          this.$toast({
            message: '请输入串码',
          });
          return
        }
        if (!that.accnumber) {
          this.$toast({
            message: '请输入操作员账号',
          });
          return
        }
        if (!that.accpassword) {
          this.$toast({
            message: '请输入操作员密码',
          });
          return
        }
        if (!that.bussnumber) {
          this.$toast({
            message: '请输入商家账号',
          });
          return
        }
        // if (!that.image) {
        //   this.$toast({
        //     message: '请上传图片',
        //   });
        //   return
        // }
        // if (files.size > 100 * 1024) {
        //   this.$toast({
        //     message: '图片不能超过200k',
        //   });
        //   return;
        // }
        requestData.card_no = that.code
        requestData.operator_account = that.accnumber
        requestData.operator_password = that.accpassword
        requestData.store_admin_account = that.bussnumber
        requestData.image = that.image
        requestData.car_no = that.car_no
        console.log("requdata", requestData)
        that.request("supplementary", requestData)
      },
      // request() {
      // this.$axios({
      //   method: '',
      //   url: '',
      //   data: this.qs.stringify({}),
      // }).then((response) => {
      //   console.log(response)
      // }).catch((error) =>
      //   console.log(error)
      // })
      //},
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          case 'supplementary':
            httper.post('coupon/supplement', requestData, res => {
              if(res.code==0){
                this.$toast({
                  message: '核销成功'
                })
              }else{
                this.$toast({
                  message:res.message || '系统异常'
                })
              }
              // that.$router.push({
              //   path: '/tixian'
              // });
            })
            break
          case 'upimg':
            httper.post('media/base64-upload', requestData, res => {
              console.log("res", res)
              if(res.code==0){
                that.image = res.data.src
              }else{
                this.$toast({
                  message:res.message || '系统异常'
                })
              }

            })
            break
        }
      },
    }
  }
</script>

<style>
  .supplementaryMesg {
    width: calc(100% - 40px);
    margin: 20px;

  }

  .supplementary-inputbox {
    margin-bottom: 20px;
  }

  .Supplementary-name {
    margin-bottom: 10px;
  }

  .Supplementary-input {
    width: 100%;
    height: 30px;
    border: 1px solid #808080;
  }

  .Supplementary-yanzhengma {
    display: flex;
    align-items: center;
  }

  .Supplementary-yanzhengimg {
    width: 30%;
    height: 30px;
    margin-right: 10px;
  }

  .Supplementary-input1 {
    width: 70%;
    height: 30px;
  }

  .tijiao-box {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  .Supplementary-tijiao {
    border-radius: 30px;
    width: 180px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
   background: #FD8C00;
   box-shadow: 0 4px 5px 2px rgba(253, 140, 0, 0.3);
    color: #fff;
  }

  .img-box {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .imgmoren {
    width: 80px;
    height: 80px;
  }

  .upimg {
    width: 80px;
    height: 80px;
  }

  input {
    /* border-radius: 5px; */
  }
  .supplementary-inputboxtip{
    color: rgba(233, 109, 85, 1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/supplementary/supplementary.vue